<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header= "Información del Cupón">
          <b-form>
            <app-tarjeta
              label="Tarjeta"
              :nombre="tarjetaNombre"
              :lista="tarjetasList"
              :labelCols="labelCols"
              :valido="tarjetaValida"
              :msjInvalido="tarjetaInvalidaMsj"
              @updated="tarjetaActualizada">
            </app-tarjeta>

            <b-form-group
              label="Lote"
              label-for="loteNumero"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="loteNumero"
                v-model.trim="$v.loteNumero.$model" 
                :state="loteNumeroValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="loteNumeroFeedback">
                {{ loteNumeroInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Cupón"
              label-for="cuponNumero"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="cuponNumero"
                v-model.trim="$v.cuponNumero.$model" 
                :state="cuponNumeroValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="cuponNumeroFeedback">
                {{ cuponNumeroInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Fecha Cupón"
              label-for="fechaCupon"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaCupon" 
                v-model="fechaCupon" 
                type="date">
              </b-form-input>
            </b-form-group>

            <app-moneda
              label="Moneda"
              :nombre="monedaNombre"
              :lista="monedasList"
              :valido="monedaValida"
              :msjInvalido="monedaInvalidaMsj"
              :labelCols="labelCols"
              @validate="validate"
              @updated="monedaActualizada">
            </app-moneda>  

            <b-form-group
              label="Importe"
              label-for="importe"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="importe"
                v-model.trim="$v.importe.$model" 
                :state="importeValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="importeFeedback">
                {{ importeInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Tarjeta from '../shared/abmSelect.vue';
import Moneda from '../shared/abmSelect.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, decimal, maxLength, minValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'tarjetacupon/getField',
  mutationType: 'tarjetacupon/updateField',
});

export default {
  name: 'ABM',
  components: {
    appTarjeta: Tarjeta,
    appMoneda: Moneda,
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      tarjetaValida: null,
      tarjetaInvalidaMsj: '',
      loteNumeroValido: null,
      loteNumeroInvalidoMsj: '',
      cuponNumeroValido: null,
      cuponNumeroInvalidoMsj: '',
      monedaValida: null,
      monedaInvalidaMsj: '',
      importeValido: null,
      importeInvalidoMsj: '',

      tarjetas: [],
      tarjetasList: [],
      monedas: [],
      monedasList: [],

      labelCols: 2,
      procesando: false
    }
  },
  computed: {
    ...mapFields([
      'id',
      'tarjeta',
      'tarjetaNombre',
      'moneda',
      'monedaNombre',
      'loteNumero',
      'cuponNumero',
      'fechaCupon',
      'importe',
    ])
  },  
  created() {
    let tarjetaCuponId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        tarjetaCuponId = this.$route.params.id;
      }
    }

    this.procesando = true;
    this.$store.dispatch('tarjetacupon/inicializar', tarjetaCuponId)
      .then(() => {
        this.procesando = false;
        this.getDatosAdicionales();
      })
      .catch(error => this.showErrorMsj(error));
  },  
  methods: {
    getDatosAdicionales() {
      const vm = this

      vm.$store.dispatch('tarjetasPlasticos/getList')
        .then(() => {
          vm.tarjetas = this.$store.getters['tarjetasPlasticos/list'];
          vm.tarjetasList = this.$store.getters['tarjetasPlasticos/selectList'];
        })
        .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar la lista de tarjetas.')));

        vm.$store.dispatch('monedas/getList')
        .then(() => {
          vm.monedas = this.$store.getters['monedas/list']
          vm.monedasList = this.$store.getters['monedas/selectList']
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar el listado de monedas'));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'loteNumero' || validarTodos) {
        if (this.$v.loteNumero.$error) {
          this.loteNumeroValido = false;
          if (!this.$v.loteNumero.required) {
            this.loteNumeroInvalidoMsj = 'Debe ingresar el número de lote';
          } else if (!this.$v.loteNumero.maxLength) {
            this.loteNumeroInvalidoMsj = 'El número de lote solo puede contener hasta 10 caracteres';
          }      
        } else {
          this.loteNumeroValido = null;
          this.loteNumeroInvalidoMsj = '';
        }
      }

      if (campo == 'cuponNumero' || validarTodos) {
        if (this.$v.cuponNumero.$error) {
          this.cuponNumeroValido = false;
          if (!this.$v.cuponNumero.required) {
            this.cuponNumeroInvalidoMsj = 'Debe ingresar el número de cupón';
          } else if (!this.$v.cuponNumero.maxLength) {
            this.cuponNumeroInvalidoMsj = 'El número de cupón solo puede contener hasta 10 caracteres';
          }      
        } else {
          this.cuponNumeroValido = null;
          this.cuponNumeroInvalidoMsj = '';
        }
      }

      if (campo == 'importe' || validarTodos) {
        if (this.$v.importe.$error) {
          this.importeValido = false;
          if (!this.$v.importe.decimal) {
            this.importeInvalidoMsj = 'El importe del cheque debe ser un valor numérico';
          } else if (!this.$v.importe.minValue) {
              this.importeInvalidoMsj = 'El importe del cheque no es válido';
          }     
        } else {
          this.importeValido = null;
          this.importeInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;
      
      let save = true;

      let tarjetaPlasticoError = true;
      if (this.tarjetaPlastico) {
        if (this.tarjetaPlastico.id) {
          if (this.tarjetaPlastico.id != 0) {
            tarjetaPlasticoError = Boolean(false);
          }
        }
      }
      if (tarjetaPlasticoError) {
        save = false;
        this.tarjetaPlasticoValida = false;
        this.tarjetaPlasticoInvalidaMsj = 'Debe seleccionar la tarjeta correspondiente.';
      }

      let monedaError = true;
      if (this.moneda) {
        if (this.moneda.id) {
          if (this.moneda.id != 0) {
            monedaError = Boolean(false);
          }
        }
      }
      if (monedaError) {
        save = false;
        this.monedaValida = false;
        this.monedaInvalidaMsj = 'Debe seleccionar la moneda correspondiente.';
      }
      
      this.$v.$touch();

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          this.procesando = true;
          this.$store.dispatch('tarjetacupon/save')
            .then(() => this.showModalMsj('Los cambios se registraron con éxito', this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error));
        } 
      }
    },
    goBack() {
      this.$router.push({ name: "TarjetasCupones" });
    },
    goList() {
      this.$router.push({ name: "TarjetasCupones" });
    },
    tarjetaActualizada(tarjetaNombre) {
      this.tarjetaNombre = tarjetaNombre;

      let tarjetaPlastico = null;
      if (this.tarjetaPlasticoNombre) {
        tarjetaPlastico = this.getSelected(this.tarjetasPlasticos, this.tarjetaPlasticoNombre);
      }
      this.$store.dispatch('tarjetacupon/setTarjetaPlastico', tarjetaPlastico);

      this.tarjetaPlasticoValida = null;
      this.tarjetaPlasticoInvalidaMsj = '';
    },
    monedaActualizada(monedaNombre) {
      this.monedaNombre = monedaNombre;

      let moneda = null;
      if (this.monedaNombre) {
        moneda = this.getSelected(this.monedas, this.monedaNombre);
      }
      this.$store.dispatch('tarjetacupon/setMoneda', moneda);

      this.monedaValida = null;
      this.monedaInvalidaMsj = '';
    }
  },
  watch: {
  },
  validations: {
    loteNumero: {
      required,
      maxLength: maxLength(10)
    },
    cuponNumero: {
      required,
      maxLength: maxLength(10)
    },
    importe: {
      decimal,
      minValue: minValue(0)
    },
  },  
}
</script>

<style>
</style>
